import { fork } from 'redux-saga/effects'

import { contractorPortalAuthSaga } from './contractorPortal/auth'
import { contractorPortalContractorSaga } from './contractorPortal/driver'
import { contractorPortalPartnersSaga } from './contractorPortal/partners'
import { contractorPortalInvoicesSaga } from './contractorPortal/invoices'
import { contractorPortalDocumentsSaga } from './contractorPortal/documents'
import { contractorPortalCertificatesSaga } from './contractorPortal/certificates'
import { contractorPortalBankInformationSaga } from './contractorPortal/bankInformation'

import { partnerSaga } from './partner'
import { remoteConfigSaga } from './remoteConfig'
import { nhtsaSaga } from './nhtsa'
import { driverSaga } from './driver'
import { lmsTrainingSaga } from './lmsTraining'
import { contractorPortalDriverDataSaga } from './contractorPortal/driverData'
import { contractorPortalDebitCardSaga } from './contractorPortal/debitCard'
import { fetchPaymentMethodSaga } from './paymentMethod'
import { authSaga } from './auth'

import { documentsSaga } from './documents'
import { personaSaga } from './persona'
import { yardstikSaga } from './yardstik'
import { docusignSaga } from './docusign'
import { optOutSaga } from './optOut'
import { ssnSaga } from './ssn'
import { temporaryDriverLicenseSaga } from './temporaryDriverLicense'
import { mcNumberSaga } from './mcNumber'
import { dotNumberSaga } from './dotNumber'
import { usDOTNumberSaga } from './usDOTNumber'
import { debitCardSaga } from './debitCard'
import { bankInformationSaga } from './bankInformation'
import { skipStepSaga } from './skipStep'
import { opportunitySaga } from './opportunity'

export function* rootSaga() {
  yield fork(authSaga)
  yield fork(opportunitySaga)
  yield fork(driverSaga)
  yield fork(documentsSaga)
  yield fork(personaSaga)
  yield fork(yardstikSaga)
  yield fork(docusignSaga)
  yield fork(optOutSaga)
  yield fork(mcNumberSaga)
  yield fork(dotNumberSaga)
  yield fork(usDOTNumberSaga)
  yield fork(debitCardSaga)
  yield fork(bankInformationSaga)
  yield fork(skipStepSaga)
  yield fork(ssnSaga)
  yield fork(temporaryDriverLicenseSaga)
  yield fork(partnerSaga)
  yield fork(contractorPortalAuthSaga)
  yield fork(contractorPortalContractorSaga)
  yield fork(contractorPortalPartnersSaga)
  yield fork(remoteConfigSaga)
  yield fork(contractorPortalInvoicesSaga)
  yield fork(contractorPortalDocumentsSaga)
  yield fork(contractorPortalCertificatesSaga)
  yield fork(contractorPortalDriverDataSaga)
  yield fork(contractorPortalBankInformationSaga)
  yield fork(contractorPortalDebitCardSaga)
  yield fork(nhtsaSaga)
  yield fork(lmsTrainingSaga)
  yield fork(fetchPaymentMethodSaga)
}
